(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 68627:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var FormikErrorMsgs = {
  required: "This field is required",
  invalidEmail: "This is not a valid email",
  invalidPhone: "This is not a valid phone",
  wrongPassword: "Password needs to be at least 8 characters long and maximum of 24 characters. It also needs to include at least one number, one special character and one uppercase letter.",
  noSpecialChars: "No special chars are allowed in this field"
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikErrorMsgs);

/***/ }),

/***/ 81519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var HeadComponent = function HeadComponent(_ref) {
  var SEO = _ref.SEO;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:title",
      content: SEO.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "og:description",
      content: SEO.description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/site.webmanifest"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "mask-icon",
      href: "/favicon/safari-pinned-tab.svg",
      color: "#5bbad5"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#2b5797"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "57x57",
      href: "/favicon/apple-icon-57x57.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "60x60",
      href: "/favicon/apple-icon-60x60.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "72x72",
      href: "/favicon/apple-icon-72x72.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "76x76",
      href: "/favicon/apple-icon-76x76.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "114x114",
      href: "/favicon/apple-icon-114x114.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "120x120",
      href: "/favicon/apple-icon-120x120.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "144x144",
      href: "/favicon/apple-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "152x152",
      href: "/favicon/apple-icon-152x152.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "/favicon/apple-icon-180x180.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "192x192",
      href: "/favicon/android-icon-192x192.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "/favicon/favicon-32x32.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "96x96",
      href: "/favicon/favicon-96x96.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "/favicon/favicon-16x16.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "manifest",
      href: "/favicon/manifest.json"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileColor",
      content: "#ffffff"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "msapplication-TileImage",
      content: "/ms-icon-144x144.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "title",
      content: SEO.title
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HeadComponent);

/***/ }),

/***/ 78990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Index; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/landing/AppStoreButton.jsx
var AppStoreButton = __webpack_require__(55448);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/landing/Header.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function Header() {
  var bannerRef = (0,react.useRef)();

  var _useState = (0,react.useState)(),
      bannerHeight = _useState[0],
      setBannerHeight = _useState[1];

  (0,react.useEffect)(function () {
    var resetBannerHeight = function resetBannerHeight() {
      var _bannerRef$current;

      setBannerHeight((_bannerRef$current = bannerRef.current) === null || _bannerRef$current === void 0 ? void 0 : _bannerRef$current.offsetHeight);
    };

    window.addEventListener("resize", resetBannerHeight);
    return function () {
      return window.removeEventListener("resize", resetBannerHeight);
    };
  }, []);
  (0,react.useEffect)(function () {
    var _bannerRef$current2;

    setBannerHeight((_bannerRef$current2 = bannerRef.current) === null || _bannerRef$current2 === void 0 ? void 0 : _bannerRef$current2.offsetHeight);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "bg-[#141518] flex flex-col md:flex-row relative w-full text-white pt-[60px] md:pt-[150px] lg:pt-[180px] pb-[50px] items-center md:items-start",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "hidden md:flex absolute top-0 left-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderBgSVGComponent, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "md:hidden flex absolute top-0 left-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderBgSVGComponent, {
        width: 270,
        height: 300
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex w-full md:w-auto md:flex-1 flex-col md:pl-12 lg:pl-24 items-start justify-start",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "px-4 md:px-0 flex flex-col space-y-4 items-center text-center md:text-left w-full md:w-auto",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
          className: "text-4xl md:text-[50px] lg:text-[64px] leading-[2.5rem] md:leading-[3.5rem] lg:leading-[4.5rem] w-full font-bold",
          children: ["Global Payments ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "and Banking for ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " Africa"]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "w-full text-lg md:text-xl lg:text-2xl text-gray-10 font-normal font-light",
          children: "Low cost, high speed international payments and invoicing in a single solution"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative flex md:hidden mt-6 w-full justify-center items-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex w-full justify-end",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            width: 560,
            height: 520,
            alt: "header_image",
            src: "/rectangles_mobile.png"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex absolute md:hidden w-[80%] min-h-[400px] items-center justify-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            objectFit: "contain",
            layout: "fill",
            alt: "header_image",
            src: "/iphones.png"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "w-full px-4 md:px-0 flex space-x-4 justify-center md:justify-start items-center mt-12",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HouseSvgComponent, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: "text-xs md:text-sm",
          children: ["Open an all-in-one business account. No minimum balance. 3% APY.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "No hidden fees."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowRightSVGComponent, {})]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "px-4 md:px-0 w-full grid-cols-2 grid gap-4",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex rounded-full w-full md:w-auto py-6 px-8 text-black bg-white mt-6 cursor-pointer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "https://zfrmz.com/bukVz5q3SzM18DSnC4PM",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              rel: "noreferrer",
              className: "w-full text-center text-sm font-bold ",
              children: "Business Sign Up"
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex rounded-full w-full md:w-auto py-6 px-8 text-white bg-[#27282F] mt-6 cursor-pointer font-bold",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "https://datamynt.com/login",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              rel: "noreferrer",
              className: "w-full text-center text-sm ",
              children: "Business Log in"
            })
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative hidden md:flex h-[700px] flex-1 justify-end",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        objectFit: "contain",
        layout: "fill",
        alt: "header_image",
        src: "/Bg_Phone.png"
      })
    })]
  });
}
Header.defaultProps = {
  handler: null
};

var ArrowRightSVGComponent = function ArrowRightSVGComponent(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", _objectSpread(_objectSpread({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M5.94 13.78a.495.495 0 0 1-.354-.147.503.503 0 0 1 0-.706L9.933 8.58a.82.82 0 0 0 0-1.16L5.586 3.073a.503.503 0 0 1 0-.706.503.503 0 0 1 .707 0l4.347 4.346c.34.34.533.8.533 1.287 0 .487-.187.947-.533 1.287l-4.347 4.346a.524.524 0 0 1-.353.147Z",
      fill: "#fff",
      fillOpacity: 0.6
    })
  }));
};

var HouseSvgComponent = function HouseSvgComponent(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M26.664 16v8a5.332 5.332 0 0 1-5.333 5.333H10.664a5.332 5.332 0 0 1-5.333-5.334v-8c0-.733.6-1.333 1.333-1.333h2.627c.733 0 1.333.6 1.333 1.333v4.187c0 .987.547 1.893 1.414 2.36a2.618 2.618 0 0 0 2.707-.12l1.266-.827 1.173.787a2.628 2.628 0 0 0 2.72.147 2.657 2.657 0 0 0 1.427-2.36v-4.174c0-.733.6-1.333 1.333-1.333h2.667c.733 0 1.333.6 1.333 1.333Zm2-6.667v1.333c0 1.467-.706 2.667-2.666 2.667h-20c-2.04 0-2.667-1.2-2.667-2.667V9.333c0-1.467.627-2.667 2.667-2.667h20c1.96 0 2.666 1.2 2.666 2.667Z",
      fill: "#0051FE"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M15.518 6.667h-7.36a1.249 1.249 0 0 1 .04-1.734l1.894-1.893a1.28 1.28 0 0 1 1.8 0l3.626 3.627Zm8.311 0h-7.36l3.626-3.627a1.28 1.28 0 0 1 1.8 0l1.894 1.893c.48.48.493 1.24.04 1.734Zm-5.201 7.999c.734 0 1.334.6 1.334 1.333v4.174c0 1.066-1.187 1.706-2.067 1.106l-1.2-.8a1.332 1.332 0 0 0-1.466 0l-1.254.827c-.88.587-2.053-.053-2.053-1.107V16c0-.733.6-1.333 1.333-1.333h5.373Z",
      fill: "#0051FE"
    })]
  }));
};

var HeaderBgSVGComponent = function HeaderBgSVGComponent(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 554,
    height: 494,
    viewBox: "0 0 754 694",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      opacity: 0.4,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        filter: "url(#a)",
        shapeRendering: "crispEdges",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M159.387 332.806a161.54 161.54 0 0 0-126.428 48.129L-75.196 491.361V197.738l247.579 56.851a161.525 161.525 0 0 0 72.717-.095l206.638-48.019a74.624 74.624 0 0 1 66.454 16.899c53.202 47.265 16.344 135.095-54.655 130.238l-304.15-20.806Z",
          fill: "url(#b)",
          fillOpacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M159.415 332.387a161.95 161.95 0 0 0-126.756 48.254l-107.434 109.69V198.266l247.064 56.733a161.955 161.955 0 0 0 72.906-.095l206.638-48.02a74.206 74.206 0 0 1 66.079 16.804c52.903 46.999 16.253 134.334-54.346 129.504l-304.151-20.805Z",
          stroke: "url(#c)",
          strokeOpacity: 0.5,
          strokeWidth: 0.841
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        filter: "url(#d)",
        shapeRendering: "crispEdges",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-121.269 487.736a150.99 150.99 0 0 0-118.174 44.987l-111.558 113.9V352.999l229.073 80.455a161.535 161.535 0 0 0 146.43-20.259l70.145-49.313c27.144-19.082 63.401-18.858 90.307.558 63.47 45.801 27.231 146.106-50.857 140.765l-255.366-17.469Z",
          fill: "url(#e)",
          fillOpacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-121.24 487.316a151.415 151.415 0 0 0-118.504 45.113L-350.58 645.592V353.593l228.513 80.258a161.958 161.958 0 0 0 146.81-20.312l70.146-49.313c26.998-18.979 63.058-18.756 89.819.555 63.127 45.554 27.084 145.317-50.582 140.004l-255.366-17.469Z",
          stroke: "url(#f)",
          strokeOpacity: 0.5,
          strokeWidth: 0.841
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        filter: "url(#g)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-109.418 103.894a161.533 161.533 0 0 1-126.427-48.129L-344.001-54.66v293.623l205.746-59.288a161.53 161.53 0 0 1 79.639-2.499l241.872 53.537a74.771 74.771 0 0 0 65.816-17.105c53.305-47.357 16.376-135.356-54.761-130.49l-303.729 20.777Z",
          fill: "url(#h)",
          fillOpacity: 0.3
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-109.389 104.314A161.957 161.957 0 0 1-236.146 56.06L-343.58-53.63v292.033l205.209-59.133a161.955 161.955 0 0 1 79.846-2.506l241.871 53.537a74.35 74.35 0 0 0 65.447-17.009c53.005-47.09 16.283-134.594-54.453-129.755l-303.729 20.777Z",
          stroke: "url(#i)",
          strokeOpacity: 0.5,
          strokeWidth: 0.841
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
        filter: "url(#j)",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-43.856-38.977a161.534 161.534 0 0 1-106.008-39.65L-230.775-149v263L60.317 56.216a161.533 161.533 0 0 1 55.801-1.246l360.108 54.908a74.852 74.852 0 0 0 50.357-10.152c64.462-39.45 36.501-138.703-39.074-138.703H-43.856Z",
          fill: "url(#k)",
          fillOpacity: 0.3
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          d: "M-43.856-38.556A161.954 161.954 0 0 1-150.14-78.31l-80.215-69.767v261.565l290.59-57.685a161.959 161.959 0 0 1 55.947-1.249l360.107 54.908a74.437 74.437 0 0 0 50.075-10.095c64.099-39.228 36.295-137.923-38.855-137.923H-43.856Z",
          stroke: "url(#l)",
          strokeOpacity: 0.5,
          strokeWidth: 0.841
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "b",
        x1: 3.048,
        y1: 816.114,
        x2: 573.468,
        y2: 71.959,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "c",
        x1: -86.975,
        y1: 526.697,
        x2: 681.158,
        y2: 143.051,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "e",
        x1: -272.757,
        y1: 971.376,
        x2: 297.664,
        y2: 227.221,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "f",
        x1: -362.779,
        y1: 681.959,
        x2: 405.354,
        y2: 298.313,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "h",
        x1: -174.775,
        y1: 91.999,
        x2: 324.724,
        y2: 195,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#007AFF",
          stopOpacity: 0
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#007AFF"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "i",
        x1: -355.779,
        y1: -89.997,
        x2: 412.354,
        y2: 293.649,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#007AFF"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#007AFF",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "k",
        x1: -129.039,
        y1: -439.883,
        x2: 307.898,
        y2: 387.584,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff",
          stopOpacity: 0.5
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("linearGradient", {
        id: "l",
        x1: -246.091,
        y1: -180.65,
        x2: 571.853,
        y2: 412.385,
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          stopColor: "#fff"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("stop", {
          offset: 1,
          stopColor: "#fff",
          stopOpacity: 0
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "a",
        x: -179.521,
        y: 93.413,
        width: 827.295,
        height: 502.273,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "BackgroundImageFix",
          stdDeviation: 52.162
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 23.557
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 11.779
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "effect1_backgroundBlur_110_4385",
          result: "effect2_dropShadow_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect2_dropShadow_110_4385",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "d",
        x: -455.326,
        y: 245.398,
        width: 777.091,
        height: 505.55,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "BackgroundImageFix",
          stdDeviation: 52.162
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          "in": "SourceAlpha",
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
          result: "hardAlpha"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feOffset", {
          dy: 23.557
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          stdDeviation: 11.779
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "hardAlpha",
          operator: "out"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feColorMatrix", {
          values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          in2: "effect1_backgroundBlur_110_4385",
          result: "effect2_dropShadow_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect2_dropShadow_110_4385",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "g",
        x: -448.326,
        y: -158.986,
        width: 827.028,
        height: 502.273,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "BackgroundImageFix",
          stdDeviation: 52.162
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_backgroundBlur_110_4385",
          result: "shape"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("filter", {
        id: "j",
        x: -335.1,
        y: -253.325,
        width: 1001.92,
        height: 471.649,
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("feFlood", {
          floodOpacity: 0,
          result: "BackgroundImageFix"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feGaussianBlur", {
          "in": "BackgroundImageFix",
          stdDeviation: 52.162
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feComposite", {
          in2: "SourceAlpha",
          operator: "in",
          result: "effect1_backgroundBlur_110_4385"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("feBlend", {
          "in": "SourceGraphic",
          in2: "effect1_backgroundBlur_110_4385",
          result: "shape"
        })]
      })]
    })]
  }));
};
;// CONCATENATED MODULE: ./components/landing/Actions.jsx





var Actions = function Actions() {
  return /*#__PURE__*/_jsxs("section", {
    id: "actions",
    className: "space-y-8 py-12 px-6 md:px-12 grid grid-cols-1 md:grid-cols-2 justify-items-start items-center bg-white",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex flex-col space-y-6 w-full items-center\t",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex py-12 flex-col space-y-12 w-10/12 text-center md:text-left md:w-3/5 items-center md:items-start md:ml-20 text-black",
        children: [/*#__PURE__*/_jsxs("h4", {
          className: "w-full pb-3 leading-tight text-left",
          children: ["Need a Business ", /*#__PURE__*/_jsx("br", {}), "Loan?"]
        }), /*#__PURE__*/_jsxs("p", {
          className: "m-0 w-100 md:w-3/3 margin-fix text-[21px] text-left",
          children: ["We\u2019ve got you covered! Fill out this form and also sign ", /*#__PURE__*/_jsx("br", {}), "up for a Data Mynt account to get started."]
        }), /*#__PURE__*/_jsx("div", {
          className: "flex rounded-full py-2 px-8 text-white bg-[#27282F] cursor-pointer",
          children: /*#__PURE__*/_jsx(Link, {
            href: "https://forms.zohopublic.com/alex218/form/LoansDataMynt/formperma/jWEBmkYoHODH05FqBQOafbGeud-9LYwzqXpoLCnl3XA",
            children: /*#__PURE__*/_jsx("a", {
              className: "w-full text-center text-sm",
              target: "_blank",
              children: "Get Started!"
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "relative w-full h-full",
      children: /*#__PURE__*/_jsx("div", {
        className: "flex absolute right-0 bottom-0 hidden md:flex",
        children: /*#__PURE__*/_jsx(Image, {
          alt: "Phone",
          width: 460,
          height: 520,
          src: "/iPhone13.svg"
        })
      })
    })]
  });
};

/* harmony default export */ var landing_Actions = ((/* unused pure expression or super */ null && (Actions)));
;// CONCATENATED MODULE: ./components/landing/Gateways.jsx






var Gateways = function Gateways() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative flex space-x-6 bg-[#141518] text-white p-8 md:p-24 w-full",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex-[3] relative space-y-12 md:w-auto w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "space-y-4 flex flex-col items-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
          children: "Data Mynt\u2019s Be Your Own Bank Token"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: ["Our native token, $BYOB, rewards transition to Data Mynt banking", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "and payments. For example, earn rewards when you open a Data Mynt", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "account, deposit funds, make payments, repay a loan, or stake for", " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "discounts on fees or better exchange rates."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "grid grid-cols-2 gap-4",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex rounded-full w-full md:w-auto py-4 px-8 text-white bg-black text-white mt-6 cursor-pointer",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://datamynt.com/login",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "w-full text-center text-sm",
                children: "Learn More"
              })
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "grid grid-cols-1 md:grid-cols-3 gap-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl w-full border border-gray-50 p-4 flex flex-col justify-start items-start space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "museum",
              src: "/museum_blue.svg",
              width: 48,
              height: 48
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["Fee free banking ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "services on-chain for ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "staking"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl w-full border border-gray-50 p-4 flex flex-col justify-start items-start space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "museum",
              src: "/id_blue.svg",
              width: 48,
              height: 48
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              children: "Tokens for referrals"
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-6",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl w-full border border-gray-50 p-4 flex flex-col justify-start items-start space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "museum",
              src: "/location_blue.svg",
              width: 48,
              height: 48
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["Discounts at Data Mynt ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "merchant locations"]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl w-full border border-gray-50 p-4 flex flex-col justify-start items-start space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "museum",
              src: "/coins_blue.svg",
              width: 48,
              height: 48
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["Rewards for power ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "customers"]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "flex items-center",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "rounded-xl  w-full border border-gray-50 p-4 flex flex-col justify-start items-start space-y-2",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "museum",
              src: "/user_blue.svg",
              width: 48,
              height: 48
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: ["Tokens for becoming an ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Agent"]
            })]
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative hidden lg:flex h-[500px] flex-1",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        layout: "fill",
        objectFit: "contain",
        objectPosition: "right bottom",
        src: "/Nothing-Phone-1.svg"
      })
    })]
  });
};

/* harmony default export */ var landing_Gateways = (Gateways);
;// CONCATENATED MODULE: ./components/landing/SellPerson.jsx





var SellPerson = function SellPerson() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "actions",
    className: "w-full py-12 md:py-24 space-y-6 flex flex-col items-center justify-center overflow-hidden",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-col w-full text-center items-center justify-center space-y-4 px-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        className: "pb-4",
        children: "Join a thriving business community"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative h-[200px] md:h-[500px] w-[200%] md:w-[105%]",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
        layout: "fill",
        objectFit: "contain",
        src: "/people.svg"
      })
    })]
  });
};

/* harmony default export */ var landing_SellPerson = (SellPerson);
// EXTERNAL MODULE: ./helpers/twBreakpoints.js
var twBreakpoints = __webpack_require__(97971);
;// CONCATENATED MODULE: ./components/landing/CryptoCheckout.jsx





var CryptoCheckout = function CryptoCheckout() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "actions",
    className: "w-full bg-[#141518] text-white flex flex-col space-y-12 md:space-y-24 justify-center items-center p-8 md:p-24",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col space-y-4 text-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
        children: "Products and Features"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "No transaction declines. No delays. Available 24 hours a day, 7 days a week."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col md:flex-row w-full space-y-4 md:space-y-0 md:space-x-12 items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hidden md:flex flex-col flex-[0.9] justify-center items-center md:items-end",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
            children: "USD or EUR Account"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-sm",
            children: ["Make payments in USD or EUR. No limits.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Deposit or withdrawal using your mobile", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "money or bank account."]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex justify-start w-full md:w-auto md:flex-[1.1]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative h-[225px] md:h-[455px] w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            objectPosition: (0,twBreakpoints/* default */.Z)("md") ? "left bottom" : "left center",
            layout: "fill",
            objectFit: "contain",
            src: "/Transaction_landing.svg"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex md:hidden flex-col w-full justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
            children: "Multicurrency Account"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-sm",
            children: ["Optimize your business\u2019s purchasing ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " power by keeping your assets in USD, ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " EUR or GBP. Deposit and withdrawal ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", "using your mobile money or bank account."]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative flex flex-col md:flex-row w-full space-y-4 md:space-y-0 md:space-x-12 items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex w-full md:w-auto md:flex-[1.1]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative h-[225px] md:h-[455px] w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            objectPosition: (0,twBreakpoints/* default */.Z)("md") ? "left bottom" : "left center",
            layout: "fill",
            objectFit: "contain",
            src: "/Checkout_landing.svg"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-[0.9] flex-col w-full justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
            children: "Cross-Border Payments"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-sm",
            children: ["Global instant payments with full ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "transparency on your ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " receivers blockchain of choice. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", "Use invoicing to get paid by ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "anyone anywhere 24/7"]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex flex-col md:flex-row w-full space-y-4 md:space-y-0 items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "hidden md:flex flex-col flex-[0.9] justify-center items-center md:items-end",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h5", {
            children: ["Point of Sale and Online ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Checkout"]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-sm",
            children: ["Accept payments from your customers using any ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " asset on any blockchain as USD or your local ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " currency. Mobile app point of sale, API or ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " checkout page integration options."]
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex justify-start w-full md:w-auto md:flex-[1.1]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative h-[225px] md:h-[455px] w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            objectPosition: (0,twBreakpoints/* default */.Z)("md") ? "left bottom" : "left center",
            layout: "fill",
            objectFit: "contain",
            src: "/GetPaid_landing.svg"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex md:hidden flex-col w-full justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
            children: "Multicurrency Account"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: "text-sm",
            children: ["Optimize your business\u2019s purchasing ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " power by keeping your assets in USD, ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " EUR or GBP. Deposit and withdrawal ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", "using your mobile money or bank account."]
          })]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative flex flex-col md:flex-row w-full space-y-4 md:space-y-0 md:space-x-12 items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex w-full md:w-auto md:flex-[1.1]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "relative h-[225px] md:h-[455px] w-full",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            objectPosition: (0,twBreakpoints/* default */.Z)("md") ? "left bottom" : "left center",
            layout: "fill",
            objectFit: "contain",
            src: "/Loans_landing.svg"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex flex-[0.9] flex-col w-full justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
            children: "COMING SOON: Business Loans"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-sm",
            children: "Finance your business with Data Mynt."
          })]
        })
      })]
    })]
  });
};

/* harmony default export */ var landing_CryptoCheckout = (CryptoCheckout);
;// CONCATENATED MODULE: ./components/landing/SettleEasy.jsx




var SettleEasy = function SettleEasy() {
  return /*#__PURE__*/_jsxs("section", {
    id: "actions",
    className: "pb-24 px-6 md:w-3/4 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 justify-items-center items-center",
    children: [/*#__PURE__*/_jsx(Image, {
      alt: "Phone",
      width: 508,
      height: 205,
      src: "/settlefunds.svg"
    }), /*#__PURE__*/_jsx("div", {
      className: "flex flex-col space-y-6 w-full items-center\t",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex flex-col space-y-4 items-center text-left",
        children: [/*#__PURE__*/_jsx("h4", {
          children: "Seamless Onboarding"
        }), /*#__PURE__*/_jsx("p", {
          children: "Get started and paid within minutes."
        })]
      })
    })]
  });
};

/* harmony default export */ var landing_SettleEasy = ((/* unused pure expression or super */ null && (SettleEasy)));
;// CONCATENATED MODULE: ./components/landing/TrackSales.jsx




var TrackSales = function TrackSales() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "actions",
    className: "w-full flex flex-col space-y-6 text-center text-white bg-[#141518] py-16 px-6 md:px-12 items-center justify-center",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      children: "Committed to unlocking opportunities for African businesses and brands"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-1 md:grid-cols-3 gap-6 lg:w-2/3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-white space-y-2 rounded-2xl p-4 flex flex-col justify-start items-start text-left text-black",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 40,
          height: 40,
          src: "/blue_wallet.svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Security"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "50,000 wallets deployed holding $90b. Fully encrypted with military grade security that has been security audited 5x."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-white space-y-2 rounded-2xl p-4 flex flex-col justify-start items-start text-left text-black",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 40,
          height: 40,
          src: "/blue_lock.svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Data Secured"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We protect your personal information and collect and use your information in accordance with legal requirements."]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bg-white space-y-2 rounded-2xl p-4 flex flex-col justify-start items-start text-left text-black",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 40,
          height: 40,
          src: "/blue_db.svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("b", {
            children: "Secured Transactions"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Your account is protected with 2 Factor Authentication and multi-sig wallet."]
        })]
      })]
    })]
  });
};

/* harmony default export */ var landing_TrackSales = (TrackSales);
;// CONCATENATED MODULE: ./components/landing/TopFintech.jsx





var TopFintech = function TopFintech() {
  return /*#__PURE__*/_jsx("section", {
    id: "topFintech",
    children: /*#__PURE__*/_jsxs("div", {
      className: "px-8 bg-wrapper text-white flex flex-col items-center justify-center space-y-12 pt-16 pb-16",
      children: [/*#__PURE__*/_jsxs("h4", {
        className: "text-center p-8 md:text-center",
        children: ["We\u2019ve Been Recognized ", /*#__PURE__*/_jsx("br", {}), " For The Work We Do"]
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex flex-row flex-wrap justify-center",
        children: [/*#__PURE__*/_jsx(Image, {
          width: 400,
          height: 450,
          alt: "Daily Finance Recognition",
          src: "/fintech.svg"
        }), /*#__PURE__*/_jsx(Image, {
          width: 400,
          height: 450,
          alt: "Daily Finance Recognition",
          src: "/finance.svg"
        }), /*#__PURE__*/_jsx(Image, {
          width: 400,
          height: 450,
          alt: "Growthlist Recognition",
          src: "/growth-list.svg"
        })]
      })]
    })
  });
};

/* harmony default export */ var landing_TopFintech = ((/* unused pure expression or super */ null && (TopFintech)));
;// CONCATENATED MODULE: ./public/quotes.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgQuotes = function SvgQuotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    fill: "#3D8ECD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m35.432 0 4.314 8.855C28.3 13.363 24.606 22.923 24.19 27.14c8.1 1.533 22.733 8.901 16.465 26.105-6.268 17.204-22.673 14.758-30.091 11.385-5.186-2.262-14.24-12.006-8.97-32.89C6.861 10.856 26.346 1.878 35.431 0ZM86.258 0l4.315 8.855c-11.446 4.508-15.14 14.068-15.557 18.285 8.1 1.533 22.733 8.901 16.465 26.105C85.213 70.449 68.81 68.003 61.39 64.63c-5.186-2.262-14.24-12.006-8.97-32.89C57.687 10.856 77.173 1.878 86.257 0Z"
  }))));
};
/* harmony default export */ var quotes = ((/* unused pure expression or super */ null && (SvgQuotes)));
;// CONCATENATED MODULE: ./components/landing/Testimony.jsx





var Testimony = function Testimony() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative w-full bg-[#141518] text-white flex flex-col py-12 space-y-12 items-center justify-center px-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
      className: "md:text-center",
      children: ["What People Are ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Saying"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflow-x-scroll w-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex space-x-6 w-[2000px]",
        children: [{
          quote: "I found DataMynt through a friend. DataMynt was so quick and easy to open my account. I didn't even need to leave my shop.",
          quoteAuthor: "Henry Okoro",
          header: "Quick and easy"
        }, {
          quote: "DataMynt's cross-border payments made is so easy to send international payments to our suppliers. They're reliable, fast and cheap.",
          quoteAuthor: "Amina Wanjiku",
          header: "Easy"
        }, {
          quote: "I started using DataMynt's invoicing for my business and it's been a game changer. My customers from all over the world can pay us instantly in their currency of choice.",
          quoteAuthor: "Mutiu Aderemi",
          header: "Game Change"
        }, {
          quote: "Instant Payments. You get paid by your customers and sed payments to suppliers globally. No Declines. No delays. Available 24 houes a day. Makes transactions seemless.",
          quoteAuthor: "Martins Chima",
          header: "Instant Payments"
        }].map(function (q) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col w-auto justify-between items-start space-y-6 p-4 rounded-[2rem] bg-[#191B1F] h-[220px]",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "space-y-2",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h6", {
                children: q.header
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: q.quote
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex space-x-2 items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "rounded-full bg-white w-10 h-10 flex items-center justify-center text-xl text-black",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: q.quoteAuthor[0]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: q.quoteAuthor
              })]
            })]
          }, q.quoteAuthor);
        })
      })
    })]
  });
};

/* harmony default export */ var landing_Testimony = (Testimony);
;// CONCATENATED MODULE: ./components/landing/Banking.jsx





var Banking = function Banking() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    className: "bg-[#141518] px-8 py-8 pb-40",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "bg-[#0051FE] rounded-[2rem] flex flex-col md:flex-row overflow-hidden",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative hidden md:flex w-[400px] items-end overflow-hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectPosition: "bottom",
          objectFit: "contain",
          layout: "fill",
          alt: "mobile_entrust",
          src: "/mobile_2.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-1 flex-col py-6 pr-6 pl-6 md:pl-0 items-start justify-center space-y-6",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "space-y-2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("h4", {
            className: "text-center md:text-left",
            children: ["5,000+ Businesses Entrust ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Data Mynt with Their Banking", " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center md:text-left",
            children: "Businesses of all sizes use DataMynt\u2019s apps and APIs to open and fund international accounts, accept & send payments, withdraw, and finance their business."
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex space-x-2 w-full justify-center md:justify-start cursor-pointer",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://play.google.com/store/apps/details?id=com.datamynt&hl=en&gl=US",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 200,
                height: 59,
                src: "/GooglePlay.svg"
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "https://apps.apple.com/us/app/datamynt-point-of-sale-pos/id1572840222",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                width: 200,
                height: 59,
                src: "/Appstore.svg"
              })
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative flex md:hidden w-full h-[200px] items-end overflow-hidden",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          objectPosition: "left bottom",
          objectFit: "contain",
          layout: "fill",
          alt: "mobile_entrust",
          src: "/mobile_2.png"
        })
      })]
    })
  });
};

/* harmony default export */ var landing_Banking = (Banking);
// EXTERNAL MODULE: ./components/landing/Container.jsx + 1 modules
var Container = __webpack_require__(94964);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 26 modules
var es = __webpack_require__(7258);
// EXTERNAL MODULE: ./node_modules/datamynt-ui-library/lib/index.esm.js
var index_esm = __webpack_require__(21627);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./components/formikErrorMsgs.js
var formikErrorMsgs = __webpack_require__(68627);
;// CONCATENATED MODULE: ./components/landing/Modal.jsx


function Modal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Modal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Modal_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Modal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var Styles = {
  errorMsg: "text-red-primary text-sm"
};
var validationSchema = es.object().shape({
  email: es.string().email(formikErrorMsgs/* default.invalidEmail */.Z.invalidEmail).required(formikErrorMsgs/* default.required */.Z.required),
  name: es.string().required(formikErrorMsgs/* default.required */.Z.required),
  message: es.string().required(formikErrorMsgs/* default.required */.Z.required)
});

var Modal = function Modal(_ref) {
  var modalOpened = _ref.modalOpened,
      closeModal = _ref.closeModal;

  var _useState = useState(false),
      success = _useState[0],
      setSuccess = _useState[1];

  var formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      message: ""
    },
    validateOnChange: false,
    onSubmit: function onSubmit(values) {
      fetch("/", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams(Modal_objectSpread({
          "form-name": "contact_modal"
        }, values)).toString()
      }).then(function () {
        setSuccess(true);
        setTimeout(function () {
          setSuccess(false);
        }, 3900);
      });
    },
    validationSchema: validationSchema,
    enableReinitialize: true
  });
  return /*#__PURE__*/_jsx("div", {
    id: "myModal",
    className: modalOpened ? "z-50 w-screen h-screen bg-opacity-80 bg-gray-90 absolute px-6" : "hidden",
    children: /*#__PURE__*/_jsx("div", {
      className: "flex justify-center items-center",
      children: /*#__PURE__*/_jsxs("div", {
        id: "modal-content",
        className: "rounded-md bg-white flex flex-col relative top-10 p-6 md:w-2/3 py-4",
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          className: "w-full flex justify-end text[#231C5E]",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx(Image, {
            alt: "Close",
            src: "/closeIcon.svg",
            width: 24,
            height: 24
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "space-y-4",
          children: [/*#__PURE__*/_jsx("h2", {
            className: "text-center sm:text-5xl text-3xl",
            children: "Contact us"
          }), /*#__PURE__*/_jsx("p", {
            className: "text-center",
            children: "Fill up the form and our team will get in touch."
          }), /*#__PURE__*/_jsxs("form", {
            className: "space-y-6 w-full md-w-3/5 md:flex md:flex-col justify-center items-center",
            "data-netlify": "true",
            name: "contact_modal",
            method: "POST",
            onSubmit: formik.handleSubmit,
            children: [/*#__PURE__*/_jsx("input", {
              type: "hidden",
              name: "form-name",
              value: "contact_modal"
            }), /*#__PURE__*/_jsx("div", {
              className: "w-full md:w-3/5",
              children:  true && /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(InputForm, {
                    onChange: formik.handleChange,
                    highlightTitle: true,
                    placeholder: "Full Name*",
                    title: "Name",
                    name: "name",
                    withBorder: true
                  }), /*#__PURE__*/_jsx("p", {
                    className: formik.errors["name"] ? Styles.errorMsg : "",
                    children: formik.errors["name"]
                  })]
                }), /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(InputForm, {
                    onChange: formik.handleChange,
                    highlightTitle: true,
                    type: "email",
                    title: "Email",
                    placeholder: "Email address*",
                    name: "email",
                    withBorder: true
                  }), /*#__PURE__*/_jsx("p", {
                    className: formik.errors["email"] ? Styles.errorMsg : "",
                    children: formik.errors["email"]
                  })]
                })]
              })
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex flex-col space-y-2 w-full md:w-3/5",
              children: [/*#__PURE__*/_jsx("label", {
                htmlFor: "message",
                className: "text-start font-normal text-sm dark:text-white text-black",
                children: "Notes"
              }), /*#__PURE__*/_jsx("textarea", {
                onChange: formik.handleChange,
                name: "message",
                className: "min-h-[125px] border rounded-sm p-2",
                placeholder: "How can we help you?*",
                id: "yourmessage"
              }), /*#__PURE__*/_jsx("p", {
                className: formik.errors["message"] ? Styles.errorMsg : "",
                children: formik.errors["message"]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "w-full md:w-3/5 pb-4 lg:pb-8",
              children: [/*#__PURE__*/_jsx(ButtonSimpleRounded, {
                submitButton: true,
                label: "Send",
                grow: true
              }), success && /*#__PURE__*/_jsx("p", {
                className: "text-primary",
                children: "Your info was sent successfully! We will get in touch shortly."
              })]
            })]
          })]
        })]
      })
    })
  });
};

/* harmony default export */ var landing_Modal = ((/* unused pure expression or super */ null && (Modal)));
// EXTERNAL MODULE: ./components/landing/Head.jsx
var Head = __webpack_require__(81519);
;// CONCATENATED MODULE: ./components/landing/InvestorsBrands.jsx





var InvestorsBrands = function InvestorsBrands() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    id: "testimony",
    className: "flex flex-col justify-center  items-center py-24 px-2 md:px-8",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      className: "text-center p-8 md:text-left",
      children: "We\u2019re Supported by Top Investors"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-1 md:grid-cols-4 gap-8 mb-0 w-full md:w-3/4 lg:w-3/5 m-0",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 226,
          height: 48,
          objectFit: "contain",
          alt: "Coinbase",
          src: "/coinbase.svg"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 226,
          height: 48,
          objectFit: "contain",
          alt: "Polygon",
          src: "/polygon.svg"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 197,
          height: 110,
          objectFit: "contain",
          alt: "Startup Haven",
          src: "/haven.svg"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 235,
          height: 32,
          objectFit: "contain",
          alt: "Angel List Ventures",
          src: "/angelist.svg"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-1 md:grid-cols-4 gap-3 space-y-2  w-full md:w-3/4 lg:w-3/5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 106,
          height: 50,
          objectFit: "contain",
          alt: "Digifinex",
          src: "/digifinex.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 100,
          height: 100,
          objectFit: "contain",
          alt: "Digitata",
          src: "/digitata.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 164,
          height: 40,
          objectFit: "contain",
          alt: "UOB",
          src: "/newUOB.jpeg"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 100,
          height: 100,
          objectFit: "contain",
          alt: "Redbeard Ventures",
          src: "/RedBeardVenturesLogoHero.png"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "grid grid-cols-1 md:grid-cols-4 gap-3 space-y-2  w-full md:w-3/4 lg:w-3/5 px-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 226,
          height: 48,
          objectFit: "contain",
          alt: "ATX Venture Partners",
          src: "/atx.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-6",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 226,
          height: 48,
          objectFit: "contain",
          alt: "Gaingels",
          src: "/gaingels.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 132,
          height: 58,
          objectFit: "contain",
          alt: "Signum",
          src: "/signum.png"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "flex items-center justify-center p-6 md:p-0",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          width: 112,
          height: 112,
          objectFit: "contain",
          alt: "Unicorn Hunter",
          src: "/latestInvestor.png"
        })
      })]
    })]
  });
};

/* harmony default export */ var landing_InvestorsBrands = (InvestorsBrands);
;// CONCATENATED MODULE: ./components/landing/Benefits.jsx





var Check = function Check() {
  return /*#__PURE__*/_jsxs("svg", {
    style: {
      minWidth: "25px"
    },
    width: "28",
    height: "28",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("rect", {
      x: "0.583333",
      y: "0.583333",
      width: "26.8333",
      height: "26.8333",
      rx: "5.25",
      fill: "url(#paint0_linear_2056_10740)",
      stroke: "url(#paint1_linear_2056_10740)",
      strokeWidth: "1.16667"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.04102 13.9999L12.3427 17.3016L18.9577 10.6982",
      stroke: "#FEFCFF",
      strokeWidth: "1.75",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_2056_10740",
        x1: "-18.8114",
        y1: "-62.1642",
        x2: "23.9338",
        y2: "-64.5787",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#42E8E0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#6940DE"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_2056_10740",
        x1: "-18.8114",
        y1: "-62.1642",
        x2: "23.9338",
        y2: "-64.5787",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#42E8E0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#6940DE"
        })]
      })]
    })]
  });
};

var Benefits = function Benefits() {
  return /*#__PURE__*/_jsxs("section", {
    className: "flex flex-col items-center justify-center space-y-12 md:space-y-16 py-24 md:px-12",
    children: [/*#__PURE__*/_jsxs("h4", {
      className: "md:text-center md:text-center px-6",
      children: ["Simple, Powerful Tools to Help", /*#__PURE__*/_jsx("br", {}), "Your Business Grow"]
    }), /*#__PURE__*/_jsxs("div", {
      className: "w-full grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-8 justify-items-center items-center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-col w-full space-y-12 text-left md:text-left px-6 md:ml-[133px] md:mr-[30px]",
        children: [{
          header: "API Integration",
          text: "Our API allows you to create seamless branded checkouts and workflows"
        }, {
          header: "Mobile App & Payments Processing Gateway",
          text: "Including point of sale, subscription / recurring payments or streaming loyalty rewards."
        }, {
          header: "Exchange and Pay Outs",
          text: "Via bank transfer or mobile money where supported."
        }, {
          header: "Tax and Accounting Support",
          text: "In addition to automated receipts and sell basis reporting."
        }].map(function (i) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex items-start",
            children: [/*#__PURE__*/_jsx(Check, {}), /*#__PURE__*/_jsxs("div", {
              className: "pl-4",
              children: [/*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx("strong", {
                  children: i.header
                })
              }), /*#__PURE__*/_jsx("p", {
                children: i.text
              })]
            })]
          }, i.header);
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "md:hidden w-full overflow-hidden pl-[10%] sm:pl-[30%] h-[370px]",
        children: /*#__PURE__*/_jsx("div", {
          className: "relative h-full w-[600px]",
          children: /*#__PURE__*/_jsx(Image, {
            alt: "Phone",
            layout: "fill",
            src: "/systemcrypto.svg"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "hidden md:flex relative w-full overflow-hidden h-[370px] md:h-auto:w-auto:px-6",
        children: /*#__PURE__*/_jsx(Image, {
          alt: "Phone",
          layout: "fill",
          objectFit: "contain",
          src: "/systemcrypto.svg"
        })
      })]
    })]
  });
};

/* harmony default export */ var landing_Benefits = ((/* unused pure expression or super */ null && (Benefits)));
// EXTERNAL MODULE: ./data/seo.json
var seo = __webpack_require__(35546);
// EXTERNAL MODULE: ./components/landing/Banner.jsx
var Banner = __webpack_require__(64293);
// EXTERNAL MODULE: ./components/landing/Nav.jsx + 4 modules
var Nav = __webpack_require__(12158);
;// CONCATENATED MODULE: ./pages/index.jsx























function Index() {
  var _useState = (0,react.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var _useState2 = (0,react.useState)("NGN"),
      currentCurrency = _useState2[0],
      setCurrentCurrency = _useState2[1];

  (0,react.useEffect)(function () {
    __webpack_require__.e(/* import() */ 1767).then(__webpack_require__.t.bind(__webpack_require__, 51767, 23)).then(function (x) {
      return x["default"];
    }).then(function (ReactPixel) {
      ReactPixel.init("356386442619688");
      ReactPixel.pageView();
    });
  });

  var ChangeCurrency = function ChangeCurrency(event) {
    setCurrentCurrency(event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* default */.Z, {
      SEO: seo
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Container/* default */.Z, {
      onCurrencyNaira: function onCurrencyNaira() {
        return ChangeCurrency("NGN");
      },
      onCurrencyShelling: function onCurrencyShelling() {
        if (currentCurrency === "KSH") {
          ChangeCurrency("NGN");
        }

        if (currentCurrency === "NGN") {
          ChangeCurrency("KSH");
        }
      },
      openModal: setOpenModal,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative bg-wrapper py-18",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Header, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-wrapper text-white",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(landing_Banking, {
          title: "Get Paid Up to $10,000 USD / Month as an Agent or Referral Partner",
          subTitle: ""
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_CryptoCheckout, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex items-center justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(landing_SellPerson, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_TrackSales, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_Gateways, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_Testimony, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(landing_InvestorsBrands, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      src: "https://www.googleoptimize.com/optimize.js?id=OPT-WWVFB9W"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "structured-data",
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FinancialService",
          name: "DataMynt",
          image: "https://datamynt.com/logo.svg",
          url: "https://datamynt.com",
          address: {
            "@type": "PostalAddress",
            streetAddress: "340 45th st",
            addressLocality: "oakland",
            addressRegion: "CA",
            postalCode: "94609",
            addressCountry: "US"
          },
          openingHoursSpecification: {
            "@type": "OpeningHoursSpecification",
            dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            opens: "00:00",
            closes: "23:59"
          },
          sameAs: ["https://www.facebook.com/datamyntbyob/", "https://twitter.com/DataMynt", "https://www.youtube.com/channel/UCM9OEOsQ198pbUhHMgKVOyw", "https://www.linkedin.com/company/datamynt/"]
        })
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((script_default()), {
      id: "viralLoops",
      children:  true && !function (a, b, c, d, t) {
        var e,
            f = a.getElementsByTagName("head")[0];

        if (!a.getElementById(c)) {
          if (e = a.createElement(b), e.id = c, e.setAttribute("data-vrlps-ucid", d), e.setAttribute("data-vrlps-version", "2"), e.setAttribute("data-vrlps-template", t), e.src = "https://app.viral-loops.com/popup_assets/js/vl_load_v2.min.js", window.ub) {
            jQuery = null, $ = null;
            var g = a.createElement(b);
            g.src = "https://code.jquery.com/jquery-2.2.4.min.js", f.appendChild(g);
          }

          f.appendChild(e);
          var h = a.createElement("link");
          h.rel = "stylesheet", h.type = "text/css", h.href = "https://app.viral-loops.com/static/vl-loader.css", f.appendChild(h);
          var i = a.createElement("div");
          i.id = "vl-overlay", i.style.display = "none";
          var j = a.createElement("div");
          j.id = "vl-loader", i.appendChild(j), a.addEventListener("DOMContentLoaded", function (b) {
            a.body.appendChild(i);

            for (var c = a.getElementsByClassName("vrlps-trigger"), d = 0; d < c.length; d++) {
              c[d].removeAttribute("href"), c[d].onclick = function () {
                a.getElementById("vl-overlay").style.display = "block";
              };
            }

            var e = a.querySelectorAll("[data-vl-widget='popupTrigger']");
            [].forEach.call(e, function (b) {
              var c = a.createElement("div");
              c.className = "vl-embedded-cta-loader", b.appendChild(c);
            });
          });
        }
      }(document, "script", "vrlps-js", "OuAXFUCuW38orf422ecQJhWVYaw", "waitlist")
    })]
  });
}

/***/ }),

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(78990);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35546:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"title":"The Future of Business Banking & Payments","description":"On-Chain Financial Infrastructure For Today’s Businesses"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,2013,260,4617,9744,9866,3874,2757,6556,5445,296,5937,906,7258,5675,2580,6770,646,9530,9464,7965,4964,8685,9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);